export const MATRIX_STATUSES = {
	scheduled: {label: "Programmato", short: "PR", tone: "scheduled"},
	present: {label: "Presente", short: "P", tone: "present"},
	absent: {label: "Assente", short: "A", tone: "absent"},
	injured: {label: "Infortunato", short: "INF", tone: "injured"},
	starter: {label: "Titolare", short: "T", tone: "present"},
	substitute: {label: "Subentrato", short: "S", tone: "substitute"},
	bench: {label: "Panchina senza ingresso", short: "P", tone: "bench"},
	lineup: {
		label: "In distinta, impiego da rilevare",
		short: "D",
		tone: "unknown",
	},
	called: {
		label: "Convocato, distinta da completare",
		short: "C",
		tone: "unknown",
	},
	"not-called": {
		label: "Non convocato nei dati della gara",
		short: "NC",
		tone: "absent",
	},
	"not-applicable": {
		label: "Non pertinente: ospite presente solo in altre date",
		short: "—",
		tone: "na",
	},
	check: {label: "Da verificare", short: "!", tone: "check"},
	unrecorded: {label: "Dato non rilevato", short: "?", tone: "unknown"},
};

export const MATCH_MATRIX_METRICS = [
	["goals", "Goal"],
	["assists", "Assist"],
	["yellowCards", "Gialli"],
	["redCards", "Rossi"],
	["goalsConceded", "Goal subiti"],
];

export const MATCH_MATRIX_SUMMARY_METRICS = MATCH_MATRIX_METRICS.filter(
	([key]) => key !== "goalsConceded",
);

export function matrixSummaryMetric(player, totals, key) {
	const metric = key === "goals" && player.goalkeeper ? "goalsConceded" : key;
	return {
		value: totals[metric],
		known: totals[metric + "Known"],
		conceded: metric === "goalsConceded",
	};
}

export function summarizeMatrixRow(row, kind) {
	const cells = Object.values(row.cells || {}).filter(
		(c) => c.status !== "not-applicable" && c.status !== "scheduled",
	);
	const attended = cells.filter((c) => c.status === "present").length;
	const played = cells.filter((c) =>
		["starter", "substitute"].includes(c.status),
	).length;
	const unknown = cells.filter(
		(c) =>
			["unrecorded", "check", "lineup", "called"].includes(c.status) ||
			c.warning ||
			(kind === "match" &&
				["starter", "substitute", "bench"].includes(c.status) &&
				c.minutes == null),
	).length;
	const minuteCells = cells.filter((c) => c.minutes != null);
	return {
		total: cells.length,
		attended: kind === "training" ? attended : played,
		unknown,
		minutes: minuteCells.length
			? minuteCells.reduce((n, c) => n + c.minutes, 0)
			: null,
		minutesKnown: minuteCells.length,
		...Object.fromEntries(
			MATCH_MATRIX_METRICS.flatMap(([key]) => {
				const known = cells.filter((c) => c[key] != null);
				return [
					[
						key,
						known.length ? known.reduce((sum, c) => sum + c[key], 0) : null,
					],
					[key + "Known", known.length],
				];
			}),
		),
	};
}
